
import { computed, defineComponent, useStore } from '@nuxtjs/composition-api'
import { setupTranslationPrefixer } from '@/assets/util'

export default defineComponent({
  props: {
    title: { type: String, required: false, default: undefined },
    image: { type: Object, required: false, default: undefined },
    imageAlt: { type: String, required: false, default: undefined },
    audioWorks: { type: Array, required: false, default: () => [] },
    theme: { type: String, required: false, default: undefined },
    headerAudioIsPlaying: { type: Boolean, required: true },
    toggleHeaderAudio: { type: Function, required: true },
  },
  setup({ audioWorks }) {
    const store = useStore()
    const playerStates = computed(() => store.getters['audio-player/playerStates'])
    const { t_ } = setupTranslationPrefixer('event-detail')
    const audioWork =
      audioWorks
        ?.slice()
        .reverse()
        .find(({ audio }) => audio?.url) || {}
    return {
      t_,
      audioWork,
      playerStates,
    }
  },
})
